import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CSelect, CSelectProps } from ".";

export const CSelectTypeSellAndRent: FC<CSelectProps> = (props) => {
  const { t } = useTranslation();
  return (
    <CSelect
      {...props}
      placeholder={t("type")}
      valueOption={{
        values: [
          { value: "sale", label: t("sell") },
          { value: "rent", label: t("rent") },
          { value: "sale-rent", label: t("sell-and-rent") },
        ],
        valueKey: "value",
        labelKey: "label",
      }}
    />
  );
};
